export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  status: string;
  roleId: string;
  role: {
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface IUserRes {
  data: IUser;
}

export interface IUsersRes {
  data: IUser[];
  count: number;
}

export enum Status {
  Active = "Active",
  Inactive = "Inactive",
  Delete = "Delete",
}

